import { render, staticRenderFns } from "./SimpleNotification.vue?vue&type=template&id=ad9c4ad0&scoped=true&"
import script from "./SimpleNotification.vue?vue&type=script&lang=js&"
export * from "./SimpleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9c4ad0",
  null
  
)

export default component.exports